import { SET_ROUTE } from '../helpers/constants/actionsConstants';

import type { RouteAction } from '../actions/types';
import type { RouteState } from '../selectors/types';

const initialState: RouteState = {
  originId: '',
  originEntityId: '',
  originName: '',
  destinationId: '',
  destinationName: '',
  destinationCityName: '',
  destinationEntityId: '',
};

const reducer = (
  state: RouteState = initialState,
  action: RouteAction,
): RouteState => {
  switch (action.type) {
    case SET_ROUTE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export { initialState };

export default reducer;
